import { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import {logout} from "../auth";
import {DASHBOARD_TABS, Tab} from "../../../components/Admin_Side/dashboardTabs";
import {AdminSidebar} from "../../../components/Admin_Side/AdminSidebar";
import AdminTopbar from "../../../components/Admin_Side/AdminTopbar";
import {AdminContent} from "../../../components/Admin_Side/AdminContent";


const Dashboard = () => {
    const [tab, setTab] = useState<Tab>('products');
    const [menuOpen, setMenuOpen] = useState(false);

    const navigate = useNavigate();
    const { t } = useTranslation();

    const tabs = DASHBOARD_TABS.map(item => ({
        ...item,
        label: t(item.translationKey),
    }));

    const handleTabChange = (newTab: Tab) => {
        setTab(newTab);
        setMenuOpen(false);
    };

    const handleLogout = () => {
        logout();
        navigate('/admin/login');
    };

    return (
        <div className="admin-layout">
            {menuOpen && (
                <div
                    className="admin-overlay"
                    onClick={() => setMenuOpen(false)}
                />
            )}

            <button
                className="admin-burger"
                onClick={() => setMenuOpen(true)}
                aria-label="Open menu"
            >
                ☰
            </button>
            <AdminSidebar
                tabs={tabs}
                activeTab={tab}
                menuOpen={menuOpen}
                onTabChange={handleTabChange}
                onLogout={handleLogout}
            />
            <main className="admin-main">
                <AdminTopbar
                    title={tabs.find(item => item.id === tab)?.label ?? ''}
                />
                <AdminContent tab={tab} />
            </main>
        </div>
    );
};

export default Dashboard;
